"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parameterize = void 0;
/**
 * Takes a string and makes it safe for url slugs.
 *
 * For Example: `My Article's title` becomes `my-articles-title`
 *
 * @param slug The string to parameterize
 */
exports.parameterize = (slug) => {
    return slug.toLowerCase().replace(/[^a-zA-Z0-9 -]/g, "").replace(/\s/g, "-");
};
//# sourceMappingURL=parameterize.js.map